(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('PaynetModeDialogController', PaynetModeDialogController);

    PaynetModeDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'PaynetMode'];

    function PaynetModeDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, PaynetMode) {
        var vm = this;

        vm.paynetMode = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.paynetMode.id !== null) {
                PaynetMode.update(vm.paynetMode, onSaveSuccess, onSaveError);
            } else {
                PaynetMode.save(vm.paynetMode, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bozorakaAdminApp:paynetModeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.lastEdited = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
